import {
  differenceInCalendarDays,
  differenceInMinutes,
  isValid
} from "date-fns";

/**
 * Teams (TEAMS_FEATURE): how long an unclaimed item has waited, or how long ago it was taken.
 * "50 m", "1 h 40 m", "1 day", "3 days". Short on purpose: it sits beside a Take it button.
 */
export const formatWaiting = (
  fromIso: string | null | undefined,
  now: Date = new Date()
): string => {
  if (!fromIso) return "";
  const from = new Date(fromIso);
  if (!isValid(from)) return "";
  const minutes = Math.max(0, differenceInMinutes(now, from));
  if (minutes < 60) return `${minutes} m`;
  if (minutes < 24 * 60) {
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return rest ? `${hours} h ${rest} m` : `${hours} h`;
  }
  const days = Math.max(1, differenceInCalendarDays(now, from));
  return days === 1 ? "1 day" : `${days} days`;
};

/** Minutes after which an unclaimed item reads as late (red). */
export const WAITING_HOT_AFTER_MINUTES = 4 * 60;

export const isWaitingHot = (
  fromIso: string | null | undefined,
  now: Date = new Date()
): boolean => {
  if (!fromIso) return false;
  const from = new Date(fromIso);
  if (!isValid(from)) return false;
  return differenceInMinutes(now, from) >= WAITING_HOT_AFTER_MINUTES;
};

/** "KR" for Karen Ruiz: the avatar initials on team rows. */
export const initialsOf = (name: string | null | undefined): string =>
  (name ?? "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");

/** The person's display name from the partial staff member a task carries. */
export const staffDisplayName = (
  person:
    | {
        fullName?: string;
        full_name?: string;
        first_name?: string;
        last_name?: string;
        name?: string;
      }
    | null
    | undefined
): string => {
  if (!person) return "";
  return (
    person.fullName ||
    person.full_name ||
    person.name ||
    [person.first_name, person.last_name].filter(Boolean).join(" ")
  );
};
